import { render } from "./ButtonNew.vue?vue&type=template&id=060f1322&scoped=true&ts=true"
import script from "./ButtonNew.vue?vue&type=script&lang=ts"
export * from "./ButtonNew.vue?vue&type=script&lang=ts"

import "./ButtonNew.vue?vue&type=style&index=0&id=060f1322&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060f1322"]])

export default __exports__